import { render, staticRenderFns } from "./LabelsTpl.vue?vue&type=template&id=1d1c05fb&"
import script from "./LabelsTpl.vue?vue&type=script&lang=js&"
export * from "./LabelsTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports